/**
 * Created by mac on 12/30/20
 */

const GameWorker = function (skin, options) {
    this.options = this.load(options);

    this.skin = skin;
    this.position = undefined;
    this.unit = undefined;
    this.start = undefined;
    this.duration = undefined;

    this.bonus = undefined;

    this.onDestructor = function () {};
};

GameWorker.prototype.destructor = function () {
    this.clearTimeout();
    this.clearBonus();

    this.onDestructor();
    this.onDestructor = function () {};
};

GameWorker.prototype.save = function () {
    const res = {};

    if (this.unit) {
        res[`${this.unit.x}_${this.unit.y}`] = cleverapps.compactTime(this.start, { seconds: true });
    } else if (this.position) {
        res[`${this.position.x}_${this.position.y}`] = 0;
    }

    return res;
};

GameWorker.prototype.load = function (stored) {
    if (!stored || stored.unit) {
        return stored;
    }

    const keys = Object.keys(stored);
    if (keys.length !== 1) {
        return;
    }

    const key = keys[0];
    const parts = key.split("_");
    const x = +parts[0];
    const y = +parts[1];
    const start = cleverapps.expandTime(stored[key], { seconds: true });

    if (x && y && start) {
        return {
            unit: { x, y },
            start
        };
    }

    if (x && y) {
        return {
            position: { x, y }
        };
    }
};

GameWorker.prototype.run = function () {
    if (this.options) {
        if (this.options.unit) {
            const unit = Map2d.currentMap.getUnit(this.options.unit.x, this.options.unit.y);

            const mineable = unit && unit.findComponent(Mineable);
            const buildable = unit && unit.findComponent(Buildable);

            let duration = this.options.duration || mineable && mineable.getTask().time || buildable && buildable.time;
            if (typeof duration === "string") {
                duration = cleverapps.parseInterval(duration);
            }

            this.setPositionNearUnit(unit, this.options.unit);

            if (!unit || typeof duration !== "number" || !this.assign(unit, duration, this.options.start)) {
                this.clearAssignment();
            }
        } else if (this.options.position) {
            this.position = this.options.position;
        }

        this.options = undefined;

        this.onUpdateState();
    }
};

GameWorker.prototype.setView = function (view) {
    this.view = view;
};

GameWorker.prototype.removeView = function () {
    this.view = undefined;
};

GameWorker.prototype.onRemove = function () {
    if (this.view) {
        this.view.removeFromParent();
    }
};

GameWorker.prototype.isInitialized = function () {
    return !this.options;
};

GameWorker.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState();
    }
};

GameWorker.SHORT_ANIMATION_DURATION = 10000;
GameWorker.MINING_ANIMATION_TIME = 1000;

GameWorker.prototype.isBusy = function () {
    return this.unit !== undefined;
};

GameWorker.prototype.canSkipAnimation = function () {
    if (this.unit) {
        const mineable = this.unit.findComponent(Mineable);
        if (mineable) {
            const task = mineable.getTask();
            if (task && task.time) {
                return cleverapps.parseInterval(task.time) === 0;
            }
        }
    }
    return false;
};

GameWorker.prototype.assign = function (unit, duration, start) {
    const canSkipAnimation = this.canSkipAnimation();

    if (this.isBusy()) {
        this.completeAssignment();
    }

    const mineable = unit && unit.findComponent(Mineable);
    const buildable = unit && unit.findComponent(Buildable);

    if (!mineable && !buildable) {
        return false;
    }

    if (buildable) {
        const instantWorker = Map2d.currentMap.workers.findInstantAssigned(buildable);
        if (instantWorker) {
            return false;
        }
    }

    if (Map2d.currentMap.workers.findAssigned(unit) || Map2d.currentMap.workers.isRetiredWorker(this)) {
        return false;
    }

    const moveToCells = this.findMoveToCells(unit, start);
    if (moveToCells === null) {
        return false;
    }

    this.unit = unit;
    this.duration = duration;
    this.start = start || Date.now();

    if (!start && moveToCells) {
        const shapeCells = unit.getShape().map((part) => ({ x: unit.x + part.x, y: unit.y + part.y }));
        const path = this.findWalkingPath(unit, {
            stopBefore: (x, y, fromX, fromY) => ISO_NEIGHBORS.some((dir) => fromX + dir.x === x && fromY + dir.y === y) && shapeCells.some((c) => c.x === x && c.y === y),
            shapeCells,
            teleport: canSkipAnimation,
            teleportFromFar: true
        });

        this.startMoving(path);
    } else {
        this.startWorking(start);
    }

    Map2d.currentMap.workers.save();
    Map2d.currentMap.workers.onChangeStatusListener();

    InfoView.CloseInfo();

    return true;
};

GameWorker.prototype.startWorking = function () {
    const mineable = this.unit && this.unit.findComponent(Mineable);
    const buildable = this.unit && this.unit.findComponent(Buildable);

    let animationTime = this.getTimeLeft();
    if (animationTime === 0) {
        animationTime = cleverapps.skins.getSlot("workerCutTime");
        if (animationTime === undefined) {
            animationTime = GameWorker.MINING_ANIMATION_TIME;
        }
        animationTime *= Map2d.animationsTimeScale();
    }

    if (!this.view) {
        throw new Error(`No view for worker: \n ${this.removeViewStack}`);
    }

    if (animationTime < GameWorker.SHORT_ANIMATION_DURATION) {
        this.timeout = cleverapps.timeouts.setTimeout(this.completeAssignment.bind(this), animationTime);
    } else {
        this.timeout = new cleverapps.LongTimeout(this.completeAssignment.bind(this), animationTime);
    }

    Map2d.currentMap.workers.assignSpeedUpBonus(this);
    const pushes = Map2dLocation.currentLocation.pushes;

    if (mineable) {
        this.view.startWorking(mineable);
        pushes.updateChopped();
    } else if (buildable) {
        cleverapps.effects.fire("buildable.start");

        this.view.startWorking(buildable);
        pushes.updateBuilt();

        cleverapps.travelBook.updateBuilt();
    }
};

GameWorker.prototype.clearAssignment = function () {
    this.clearTimeout();

    this.unit = undefined;
    this.start = undefined;
    this.duration = undefined;

    this.clearBonus();

    Map2d.currentMap.workers.save();
    Map2d.currentMap.workers.onChangeStatusListener();

    this.onUpdateState();
};

GameWorker.prototype.completeAssignment = function (extraTime) {
    if (!this.isBusy()) {
        return;
    }

    const timeSpent = Date.now() - this.start + (extraTime || 0);
    const unit = this.unit;

    this.clearAssignment();

    const mineable = unit.findComponent(Mineable);
    if (mineable) {
        mineable.completeMining(this);
        this.view.complete(mineable);
    }

    const buildable = unit.findComponent(Buildable);
    if (buildable) {
        if (buildable.time > timeSpent) {
            unit.suspendBuilding(timeSpent);
        } else {
            unit.completeBuilding();
        }

        this.view.complete(buildable);
    }

    Map2d.currentMap.workers.adjustRegularIfNeeded();
};

GameWorker.prototype.getTimeLeft = function () {
    return Math.max(this.duration - (Date.now() - this.start), 0);
};

GameWorker.prototype.getFullJobTime = function () {
    if (!this.isBusy()) {
        return;
    }

    const build = this.unit.findComponent(Buildable);
    if (build) {
        return cleverapps.parseInterval(this.unit.getData().buildable);
    }

    const mine = this.unit.findComponent(Mineable);
    if (mine) {
        return cleverapps.parseInterval(mine.getTask().time);
    }
};

GameWorker.prototype.clearTimeout = function () {
    if (this.timeout instanceof cleverapps.CountDown) {
        this.timeout.remove();
        this.timeout = undefined;
    } else if (typeof this.timeout === "object") {
        cleverapps.timeouts.clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

GameWorker.prototype.speedUpPartially = function (extraTime, animateTimer) {
    if (!this.isBusy()) {
        return;
    }

    const unit = this.unit;

    this.speedupInProgress = true;
    const assignExtraTime = function () {
        this.completeAssignment(extraTime);

        const buildable = unit.findComponent(Buildable);
        if (buildable && !buildable.isCompleted()) {
            this.assign(unit, buildable.time);
        }

        this.speedupInProgress = false;
        Map2dLocation.currentLocation.pushes.updateBuilt();
        Map2dLocation.currentLocation.pushes.updateChopped();
    }.bind(this);

    if (animateTimer && this.unit.onGetView()) {
        this.view.showSpeedUp(unit, Math.min(extraTime, this.getTimeLeft()), assignExtraTime);
    } else {
        assignExtraTime();
    }
};

GameWorker.prototype.speedUp = function () {
    const data = { affected: this.unit };
    Map2d.mapEvent(Map2d.SPEED_UP, data);
    cleverapps.tutorial.trigger(Map2d.SPEED_UP, data);

    this.speedUpPartially(this.getTimeLeft());
};

GameWorker.prototype.setSpeedUpBonus = function () {
    if (!this.bonus) {
        this.bonus = {
            time: Workers.SPEEDUP_BONUS_TIME,
            timeout: new cleverapps.LongTimeout(this.clearBonus.bind(this), cleverapps.parseInterval(Workers.SPEEDUP_BONUS_DURATION))
        };
    }
};

GameWorker.prototype.clearBonus = function () {
    if (this.bonus) {
        clearTimeout(this.bonus.timeout);
        this.bonus = undefined;
    }
};

GameWorker.prototype.isSpeedUpBonusAvailable = function () {
    return connector.ads.isRewardedAvailable && this.isBusy() && this.getTimeLeft() > cleverapps.parseInterval(Workers.SPEEDUP_BONUS_MINIMUM_REQUIRED_TIME) && this.unit.findComponent(Buildable);
};

GameWorker.prototype.isSpeedUpBonusActive = function () {
    return this.bonus;
};

GameWorker.prototype.speedUpForVideo = function () {
    if (!this.isBusy()) {
        return;
    }

    cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.SPEEDUP, () => {
        this.speedUpPartially(cleverapps.parseInterval(Workers.SPEEDUP_BONUS_TIME), true);
    });
};

GameWorker.prototype.findNearestAvailableCell = function (cell) {
    const moveToCells = [];

    const cellFilter = GameWorker.canWalk || GameWorker.canMove;

    Map2d.currentMap.iterateBfs(cell.x, cell.y, (cell) => {
        if (cellFilter(cell)) {
            if (moveToCells.length && moveToCells[0].step !== cell.step) {
                return true;
            }
            moveToCells.push(cell);
        }
    });

    if (!moveToCells.length) {
        return;
    }

    const relativePosition = this.position || cell;

    let bestMoveCell = moveToCells[0];
    let bestMoveDistance = cc.pDistanceSQ(relativePosition, bestMoveCell);

    for (let i = 1; i < moveToCells.length; i++) {
        const distance = cc.pDistanceSQ(relativePosition, moveToCells[i]);
        if (distance < bestMoveDistance) {
            bestMoveCell = moveToCells[i];
            bestMoveDistance = distance;
        }
    }

    return bestMoveCell;
};

GameWorker.prototype.hasPosition = function () {
    return Boolean(this.position);
};

GameWorker.prototype.getSkin = function () {
    return this.skin;
};

GameWorker.prototype.getMapPosition = function () {
    return this.view ? this.view.getMapPosition() : cc.p(0, 0);
};

GameWorker.canMove = function (cell) {
    const map = Map2d.currentMap;

    if (map.getFog(cell.x, cell.y)) {
        return false;
    }

    let unit = map.getUnit(cell.x, cell.y);
    if (unit) {
        unit = unit.head || unit;

        const multicell = unit.findComponent(MultiCell);
        if (multicell) {
            return multicell.canMoveThrough(cell.x, cell.y);
        }

        return false;
    }

    if (!map.isGround(cell.x, cell.y) && !map.isWaterUnit(cell.x, cell.y)) {
        return false;
    }

    return true;
};
